import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { AppComponent } from '../app.component';
import { ChatNotificationService } from '../services/chat-notification.service';
import { WhatsAppChatService } from '../services/whatsapp-chat.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})

export class LoginComponent implements OnInit {
  model: any = {};
  user: any = {};
  public urlvalue: string;
  datas: any = {};
  lowerUser: any = {};
  count: number;
  showloader: boolean;
  currentUser: any;
  constructor(
    public router: Router,
    public activeRouter: ActivatedRoute,
    private loginservice: LoginService,
    private _flashMessagesService: FlashMessagesService,
    private appComponent: AppComponent,
    private chatNotificationService: ChatNotificationService,
    private whatsappService: WhatsAppChatService
  ) {
  }
  ngOnInit() {
    this.showloader = true;
    // Clear all localStorage on landing login page
    localStorage.clear();
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    if (this.currentUser) {
      // alert('curr')
      this.loginservice.deletePastCheckouts(this.currentUser.salon_id).subscribe(data => {
      }, error => { alert('Network Error deletePastCheckouts API'); });
    } else {
      this.appComponent.ngOnInit();
      // alert('nooooocurr')
    }
    this.showloader = false;

    let id;
    this.urlvalue = '#/';
    if (this.loginservice.getLocalSession('lowerUser') != null) {
      this.lowerUser = JSON.parse(this.loginservice.getLocalSession('lowerUser'));
    }

  }
  // Login function to call Login Service
  loginf() {
    this.loginservice.login(this.user)
      .subscribe(
        data => {
          if (data['status'] === 'success') {
            delete data['status'];
            delete data['message'];
            this.loginservice.setLocalSession(data, 'currentUser');
            // After successful login and setting localStorage
            // this.chatNotificationService.initializeAfterLogin();
            // Also trigger WhatsApp service polling
            this.whatsappService.startPollingIfAllowed();

            // Wait longer for initial data fetch
            setTimeout(() => {
              // Force notification service to reinitialize after data is loaded
              this.chatNotificationService.initializeAfterLogin();
              // Force widget to reinitialize by triggering change detection
              window.dispatchEvent(new Event('storage'));
            }, 5000);

            this._flashMessagesService.show('Logged in Successfully', { cssClass: 'alert-success' });
            localStorage.removeItem('lowerUser');
            this.router.navigate(['Selectport']);
          } else {
            this._flashMessagesService.show(data['message'], { cssClass: 'alert-danger' });
          }
        },
        error => {
          alert('Network Error Login API');
          this._flashMessagesService.show('Error in the Data/Server', { cssClass: 'alert-danger' });
        });
  }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts